import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import { SEGMENT_BY_SLUG } from "@/lib/segments";
import SegmentRoute from "@/pages/SegmentRoute";

export const Route = createFileRoute("/agente-ia-seguros")({
  head: () => buildHead({
    title: SEGMENT_BY_SLUG["agente-ia-seguros"]!.metaTitle,
    description: SEGMENT_BY_SLUG["agente-ia-seguros"]!.metaDescription,
    path: "/agente-ia-seguros",
  }),
  component: () => <SegmentRoute slug="agente-ia-seguros" />,
});
